// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"27310a07","453":"fc107489"}[chunkId] + ".chunk.js";
};